import React from 'react';
import PropTypes from 'prop-types';
import './LinkButton.scss';

const propTypes = {
  text: PropTypes.string.isRequired,
  clickHandler: PropTypes.func,
};

const defaultProps = {
  clickHandler: () => undefined,
};

const localClickHandler = (e, func) => {
  e.preventDefault();
  func();
};

const LinkButton = ({ text, clickHandler }) => (
  <button className="link-button" onClick={e => localClickHandler(e, clickHandler)}>{text}</button>
);

LinkButton.propTypes = propTypes;
LinkButton.defaultProps = defaultProps;

export default LinkButton;



// WEBPACK FOOTER //
// ./src/components/_atomic/LinkButton/LinkButton.js